export abstract class StyleHelper {
  public static getColorStyle(backColor: string, textColor: string): string {
    let css = '';
    if ((backColor ?? '') != '') {
      css = 'background-color: #' + backColor + ';';
    }
    if ((textColor ?? '') != '') {
      css = css + 'color: #' + textColor + ';';
    }
    return css;
  }
}
